

















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { FaxLine, ForwardingNumber } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService, userService } from '@/shared';
import { Utils } from '@/helper/utils';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class SaveForwardingNumberPage extends Base {
  public phoneMask: string = '##########';
  public forwardingNumbersFields: Array<VFields<any>> = [];
  public forwardingNumbersModel: ForwardingNumber = {
    id: '',
    name: '',
    alynkNumber: '',
    forwardingNumber: '',
  };

  public storeId: number = 0;
  public form: any = {};
  public forwardingNumberId: string = '';

  public requestProgress: boolean = false;
  public userList: any[] = [];

  public callMethod(methodName): void {
    if (methodName === 'backToStoreEdit') {
      this.$router
        .push({
          name: 'admin.stores.edit',
          params: { id: this.storeId.toString(), tab: 'ForwardingNumber' },
        })
        .catch((ex) => {
          console.log(ex);
        });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.saveForwardingNumers();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('stores.btnBackToStoreTitle'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('stores.btnBack'),
        click: 'backToStoreEdit',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    this.storeId = Number(this.$route.params.storeId);
    if (this.$route.params.forwardingId) {
      this.forwardingNumberId = this.$route.params.forwardingId;
    }

    this.setForwardingNumbersFields();
    if (this.$route.params.storeId) {
      this.getStoreInfo();
    }

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public setForwardingNumbersFields(): void {
    this.forwardingNumbersFields = [
      {
        key: 'name',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          label: 'Name',
          loading: false,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
        },
      },
      {
        key: 'alynkNumber',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          counter: 10,
          disabled: false,
          label: 'ALynk Number',
          loading: false,
          mask: this.phoneMask,
          prefix: '+1',
          hint: Utils.PhoneNoHint,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules: [
            v => this.PhoneNumber(v)
          ]
        },
      },
      {
        key: 'forwardingNumber',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          counter: 10,
          disabled: false,
          label: 'Forwarding Number',
          loading: false,
          mask: this.phoneMask,
          prefix: '+1',
          hint: Utils.PhoneNoHint,
          elementClass: 'col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 float-left',
          rules: [
            v => this.PhoneNumber(v),
          ]
        },
      },
    ];
  }

  public async getStoreInfo(): Promise<void> {
    try {
      this.formlyShowSkeleton(this.forwardingNumbersFields);
      const response = await storeService.getStore(this.storeId);
      const selectedForwardingNumber = response.storeJson.forwardingNumbers.find(
        (m) => m.id === this.$route.params.forwardingId
      );

      if (selectedForwardingNumber && selectedForwardingNumber.forwardingNumber.includes('+1')) {
        selectedForwardingNumber.forwardingNumber = selectedForwardingNumber.forwardingNumber.replaceAll(
          '+1',
          ''
        );
      }
      if (selectedForwardingNumber && selectedForwardingNumber.alynkNumber.includes('+1')) {
        selectedForwardingNumber.alynkNumber = selectedForwardingNumber.alynkNumber.replaceAll(
          '+1',
          ''
        );
      }
      if (this.forwardingNumberId) {
        this.forwardingNumbersModel.id = selectedForwardingNumber.id;
        this.forwardingNumbersModel.name = selectedForwardingNumber.name;
        this.forwardingNumbersModel.alynkNumber =
          selectedForwardingNumber.alynkNumber;
        this.forwardingNumbersModel.forwardingNumber =
          selectedForwardingNumber.forwardingNumber;
      }
    } finally {
      this.formlyHideSkeleton(this.forwardingNumbersFields);
    }
  }

  public validateForwardingNumber(): Vue & { validate: () => boolean } {
    return this.$refs.forwardingNumberForm as Vue & { validate: () => boolean };
  }


  public async saveForwardingNumers(): Promise<void> {
    if (this.validateForwardingNumber().validate()) {
      try {
        this.requestProgress = true;
        this.$emit('update:progress', this.requestProgress);
        const numbers = /^[0-9]+$/;
        if (!this.forwardingNumbersModel.alynkNumber.match(numbers)) {
          this.showAlert(false, 'Alphabets are not allowed on Number fileds');
          return;
        }
        if (!this.forwardingNumbersModel.forwardingNumber.match(numbers)) {
          this.showAlert(false, 'Alphabets are not allowed on Number fileds');
          return;
        }
        if (this.forwardingNumbersModel.id === '') {
          await storeService.saveForwardingNumber(
            this.storeId,
            this.forwardingNumbersModel
          );
          this.showAlert(true, 'Forwarding Number Added successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                tab: 'ForwardingNumber'
              }
            })
            .catch((ex) => {
              console.log(ex);
            });
        } else {
          await storeService.updateForwardingNumber(
            this.storeId,
            this.forwardingNumbersModel
          );
          this.showAlert(true, 'Forwarding Number Updated successfully');
          this.$router
            .push({
              name: 'admin.stores.edit',
              params: {
                storeId: this.storeId.toString(),
                tab: 'ForwardingNumber'
              },
            })
            .catch((ex) => {
              console.log(ex);
            });
        }
      } finally {
        this.requestProgress = false;
        this.$emit('update:progress', this.requestProgress);
      }
    }
  }
}
